import axios from 'axios'

export const getAllWard = (params) => {
  return axios.get('wards', {params: params})
}

export const getWard = (id, params) => {
  return axios.get('wards/' + id, {params: params})
}

export const getWardKind = (params) => {
  return axios.get('helpers/wards', {params: params})
}

export const addWard = (data) => {
  return axios.post('wards', data)
}

export const editWard = (id, data) => {
  return axios.put('wards/' + id, data)
}

export const deleteWard = (id) => {
  return axios.delete('wards/' + id)
}

export const restoreWard = (id) => {
  return axios.post('wards/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/ward.js